<app-manage-template [title]="'Manage Business Networks'"  [COLUMNFIELDS]="columns"
[userData]="(userDatas | async)" [parentData]="businessNetworkDetails" [KEY]="'MANAGE_BUSINESS_NETWORK'"
(updateParent)="updateBusinessNetwork($event)" [holder]="'Search by network name'"
(updateMembers)="updateContactMembers($event)" [onSearch]="onSearch" [dropdownContext]="filerData"
[onFilter]="onFilter" [this]="this" [onScroll]="onScroll">

<div class="row mt-1">
  <app-plan-card [cards]="allocationCards" [TOTAL]="PLANMAX"></app-plan-card>

</div>


</app-manage-template>
